import { Injectable } from '@angular/core';
import { AppConfigurationService, ApplicationType } from '@x/service/app-configuration.service';

@Injectable()
export class AppConfigurationServiceImpl extends AppConfigurationService {
  getApp(): ApplicationType {
    return 'app';
  }
}
